import { StateCreator } from "zustand";
import { FetchState } from "../../../domain/models/fetch-state";
import { AxiosHttpClient } from "../../../infra/http/axios-http-client";
import { getDataKeyFromLocalStorage } from "../../../common/utils/AuthToken";
import { AUTH_HEADER, SECURE_AUTH_TOKEN_KEY, SECURE_BASE_URL_KEY } from "../../../base";
import Endpoints from "../../../domain/endpoints";
import { AddInputAcknowledgement } from "../../../domain/useages/user-input-acknowledgement/add-user-input-acknowledgement";
import { RemoteAddInputAcknowledgement } from "../../../data/usecases/user-input-acknowledgement/remote-add-user-acknowledgement";

export interface AddInputAcknowledgementSliceInterface {
  AddInputAcknowledgementState: FetchState;
  AddInputAcknowledgement: Function;
}

const initialStates = {
  AddInputAcknowledgementState: FetchState.DEFAULT,
};

const axiosHttpClient = AxiosHttpClient.getInstance();


export const useAddInputAcknowledgementSlice: StateCreator<
  AddInputAcknowledgementSliceInterface
> = (set) => ({
  ...initialStates,
    AddInputAcknowledgement: async (payload: AddInputAcknowledgement.Params) => {
  
    const token = getDataKeyFromLocalStorage(SECURE_AUTH_TOKEN_KEY) ??"";
    const BASE_URL = getDataKeyFromLocalStorage(SECURE_BASE_URL_KEY);

    axiosHttpClient.setAuthHeaders({
      [AUTH_HEADER]: token.toString(),
    });

    const remoteAddInputAcknowledgement = new RemoteAddInputAcknowledgement(
      `${BASE_URL}${Endpoints.ADD_USER_INPUT_ACKNOWLEDGEMENT}`,

      axiosHttpClient
    );

    set(() => ({ AddInputAcknowledgementState: FetchState.LOADING }));
    let result = await remoteAddInputAcknowledgement.add(payload);
    return result;
  },
});
